import {HistoricalPriceService} from "./historical/HistoricalPriceService";

export default angular.module("tfApp.services.price", [])
                      .service(HistoricalPriceService.id, HistoricalPriceService)
                      .name;
